import { z } from 'zod';

import { zodLedgerAccountTypeSchema } from '../validations';

export { zodLedgerAccountSchema as zodUpdateLedgerAccountResponseSchema } from '../validations';

/**
 * Update payload for opening a new effective-dated version of a ledger
 * account. `companyId` and `number` are immutable and not part of this
 * request. `accountType`, `costType`, and `name` are nullable: omitting one
 * leaves its current value untouched, sending `null` explicitly clears it.
 * `validFrom` is required whenever one of the other fields changes.
 */
export const zodUpdateLedgerAccountPayloadSchema = z.object({
  accountType: zodLedgerAccountTypeSchema.nullable().optional(),
  costType: z.string().trim().max(255).nullable().optional(),
  name: z.string().trim().max(255).nullable().optional(),
  validFrom: z.iso.date().optional(),
});
